export const incontroMitCapitanerie2025 = {
  id: 'static-incontro-mit-capitanerie-2025',
  slug: 'incontro-mit-capitanerie-2025',
  title: 'Incontro al MIT: dialogo costruttivo con la Direzione Generale per il Mare',
  excerpt: 'Proficuo incontro l\'8 luglio presso il MIT con la Direttrice Generale per il mare Dottoressa Patrizia Scarchilli per discutere le problematiche degli STED nel settore nautico.',
  body: `
    <div style="background: white; color: #001510; padding: 2rem; border-radius: 12px; margin: 2rem 0; text-align: center; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); border: 2px solid #00bf8f;">
      <h2 style="font-size: 2rem; margin-bottom: 1rem; font-weight: 600; color: #001510;">
        <i class="fas fa-handshake"></i> Proficuo incontro al MIT
      </h2>
      <p style="color: #2c3e50; font-size: 1.1rem; line-height: 1.6;">
        Proficuo incontro oggi 8 luglio presso il <strong>Ministero dei Trasporti e delle Infrastrutture</strong>, alla presenza della <strong>Direttrice Generale per il mare, il trasporto marittimo e per vie d'acqua interne Dottoressa Patrizia Scarchilli</strong> coadiuvata dai funzionari dell'UCON.
      </p>
    </div>

    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.05) 0%, rgba(0, 21, 16, 0.02) 100%); border: 2px solid #00bf8f; border-radius: 12px; padding: 2rem; margin: 2rem 0;">
      <h3 style="color: #001510; margin-bottom: 1.5rem; font-size: 1.5rem;">
        <i class="fas fa-users"></i> Partecipanti UNASCA
      </h3>
      <ul style="list-style: none; padding: 0;">
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          🏛️ Per l'UNASCA erano presenti il <strong>Vice Segretario Studi Francesco Osquino</strong>
        </li>
        <li style="margin-bottom: 1rem; padding-left: 2rem; position: relative; line-height: 1.6;">
          🏛️ Il <strong>Responsabile Nazionale Nautica Studi Marco D'Agliano</strong>
        </li>
      </ul>
    </div>

    <h2><i class="fas fa-clipboard-list"></i> Temi Trattati</h2>

    <div style="background: white; border-radius: 12px; padding: 2rem; margin: 2rem 0; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <h3 style="color: #001510; margin-bottom: 1rem;">
        <i class="fas fa-archive"></i> Problema dell'Archiviazione Documenti
      </h3>
      <p>I temi trattati vertevano in primis sul <strong>problema dell'obbligo di conservare i documenti di navigazione</strong> per ogni formalità nautica in capo agli STED, invece che come previsto dal DPR 152 inviarli ad UCON.</p>

      <p>Avendo raggiunto l'archiviazione dei documenti una dimensione considerevole che stanno mettendo in crisi gli uffici, si è proposto di <strong>formulare una modifica al DPR 152/2018</strong> affinché le copie a suo tempo inviate ad UCON diventino digitali a firma degli STED.</p>

      <p>Quindi, dopo un periodo di conservazione, sia prevista la possibilità di <strong>distruggere i documenti dagli STED conservati</strong>.</p>
    </div>

    <div style="background: white; border-radius: 12px; padding: 2rem; margin: 2rem 0; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <h3 style="color: #001510; margin-bottom: 1rem;">
        <i class="fas fa-certificate"></i> Rinnovo Certificato di Sicurezza
      </h3>
      <p>Un altro tema molto sentito riguarda le <strong>formalità di rinnovo certificato di sicurezza</strong>, essendo attualmente impossibilitati al rilascio di un permesso di navigazione malgrado l'imbarcazione sia stata visitata dall'ente tecnico che ne ha rilasciato parere favorevole.</p>

      <p>Anche per questa problematica, si valuta di proporre un'ulteriore modifica al citato DPR 152 che consenta, come nelle trascrizioni di proprietà, il <strong>rilascio di un permesso provvisorio da parte degli STED</strong> che consenta la navigazione in attesa della convalida del certificato in questione.</p>
    </div>

    <div style="background: white; border-radius: 12px; padding: 2rem; margin: 2rem 0; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <h3 style="color: #001510; margin-bottom: 1rem;">
        <i class="fas fa-id-card"></i> Licenze di Navigazione
      </h3>
      <p>Abbiamo inoltre evidenziato che molte UMC sono sprovviste delle <strong>Licenze di Navigazione</strong> ed obbligano gli STED a comprare le stesse in misura consistente presso le CP che chiedono il pagamento anticipato, mentre le poche UMC che ne sono in possesso le rilasciano gratuitamente senza costi.</p>

      <p>La Direttrice farà le opportune verifiche al fine di <strong>rendere omogenea la consegna delle licenze a livello nazionale</strong>, che saranno poi pagate attraverso il sistema PAGOPA all'effettivo utilizzo delle stesse.</p>

      <p><strong>Per queste tematiche chiediamo ai soci di segnalare a questa sede eventuali difformità in proposito.</strong></p>
    </div>

    <div style="background: white; border-radius: 12px; padding: 2rem; margin: 2rem 0; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <h3 style="color: #001510; margin-bottom: 1rem;">
        <i class="fas fa-globe"></i> Navigazione all'Estero dei Natanti
      </h3>
      <p>Si è dedicato un approfondimento in relazione alle <strong>attestazioni per la navigazione all'estero dei natanti</strong>, per verificare la possibilità dell'accettazione da parte degli stessi di un documento che fa parte di una legge emanata dall'Italia e che è stato creato per consentire la navigazione in acque territoriali straniere.</p>
    </div>

    <h2><i class="fas fa-handshake"></i> Prospettive Future</h2>

    <p>Sia UNASCA con i propri rappresentanti, sia la Direttrice Generale hanno auspicato di <strong>promuovere incontri periodici</strong> che possano favorire semplificazioni procedurali, a tutela dei diportisti ma anche come miglior operatività sia dell'UCON sia degli STED.</p>

    <div style="text-align: center; margin: 2rem 0;">
      <img src="/images/capitanerie.jpg" alt="Incontro MIT Capitanerie di Porto - UNASCA" style="width: 100%; max-width: 800px; border-radius: 12px; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <p style="margin-top: 1rem; font-size: 0.9rem; color: #6c757d; text-align: center; font-style: italic;">
        <i class="fas fa-anchor"></i> Incontro al Ministero dei Trasporti e delle Infrastrutture
      </p>
    </div>
  `,
  featuredImage: '/images/capitanerie.jpg',
  category: {
    id: 'normative',
    name: 'Normative',
    slug: 'normative',
    color: '#F59E0B'
  },
  tags: ['MIT', 'Capitanerie di Porto', 'STED', 'Nautica', 'DPR 152'],
  author: {
    id: 'unasca-admin',
    username: 'UNASCA',
    profile: {
      firstName: 'UNASCA',
      lastName: 'Nazionale',
      fullName: 'UNASCA Nazionale'
    }
  },
  status: 'PUBLISHED' as const,
  visibility: 'PUBLIC' as const,
  publishedAt: '2025-07-08T14:00:00Z',
  createdAt: '2025-07-08T14:00:00Z',
  updatedAt: '2025-07-08T14:00:00Z',
  metadata: {
    views: 0,
    likeCount: 0,
    shares: 0
  },
  readingTime: 5
};

